<template>
    <div>
        <div class="row my-1 pl-4 pr-4">
            <div class="col">
                <base-input alternative=""
                            v-bind:readonly="isLoading"
                            placeholder="Nach Mitarbeiter suchen"
                            input-classes="form-control-alternative form-control-lg"
                            v-model="search"
                />
            </div>
        </div>
        <div class="row my-1 pl-4 pr-4 d-flex align-items-center">
            <div class="col-xl-2">
                <base-alert type="secondary">
                    <span class="alert-inner--icon"><i class="fas fa-filter"></i></span>
                    <span class="alert-inner--text"><strong>Ungültig</strong> in <strong>{{weeks}}</strong> Wochen<br>
                    <em>- am {{expiryDate|formatDateToDay}}</em></span>
                    <b-form-input  type="range" v-model="weeks" min="0" max="24"></b-form-input>
                </base-alert>
            </div>
            <div v-if="disabledCols.length > 0" class="col-sm-6 p-4">
                <div class="text-muted">ausgeblendete Spalten:<br><badge type="default" v-for="(col,i) in disabledCols" :key="i+'dcols'" v-on:click.native="() => { cols.push(col); disabledCols.splice(i,1); }">{{col}}</badge></div>
            </div>
            <div v-if="filteredStatus.length > 0" class="col-sm-4 p-4">
                <base-button icon="fas fa-undo " type="secondary" @click="filteredStatus = []">Filter</base-button>
            </div>
        </div>
        <div class="table-responsive">
        <fade-transition>

                <base-table :key="weeks*profiles.length+'blub'" class="table align-items-center table-flush"
                            tbody-classes="list"
                            thead-classes="thead-light"
                            :data="profiles">
                    <template slot="columns">
                        <th style="width: 80px; white-space: normal !important;">Mitarbeiter</th>
                      <!---<th style="width: 80px; white-space: normal !important;" v-if="isAdmin">Organisation</th> --->
                      <!---<th style="width: 80px; white-space: normal !important;">Standort</th>--->
                        <th v-for="(col,i) in cols" :key="i+'-cols'" class="text-center" style="width: 80px; white-space: normal !important;" @mouseenter="() => { showColumnOptions.push(col); }" @mouseleave="() => { showColumnOptions = [];}">
                            <div class="row align-items-center">
                                <div class="col-10 pr-0"><i v-show="filteredStatus.some(item => item.col === col)" class="fas fa-filter"></i> {{col}}</div>
                                <div class="col-2 pl-0" :key="tick+col+'docs'">
                                    <base-dropdown v-show="showColumnOptions.includes(col)" class="dropdown"
                                                   position="right">
                                        <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="fas fa-ellipsis-v"></i>
                                        </a>
                                        <template>
                                            <ul class="dropdown-item" @click="() => { disabledCols.push(col); cols.splice(i,1); }"><i class="fas fa-eye-slash"></i>Spalte ausblenden</ul>
                                            <ul class="dropdown-item text-center text-muted"><i class="fas fa-filter"></i> <em>Filtern</em></ul>

                                            <ul class="dropdown-item" v-if="!filteredStatus.some(obj =>  obj.col === col && obj.status === 'success' )" @click="() => { filteredStatus.push({col: col, status: 'success'}); tick++;}"><i class="fas fa-circle text-success" alt="gültig"></i>gültig</ul>
                                            <ul class="dropdown-item" v-else @click="() => { filteredStatus = arrayRemove(filteredStatus,{col: col, status: 'success'}); tick++;}"><i class="fas fa-circle text-secondary" alt="gültig"></i>gültig</ul>

                                            <ul class="dropdown-item" v-if="!filteredStatus.some(obj =>  obj.col === col && obj.status === 'warning' )" @click="() => { filteredStatus.push({col: col, status: 'warning'}); tick++;}"><i class="fas fa-circle text-warning" :alt="'ungültig in '+weeks+' Wochen'"></i>ungültig in {{weeks}} Wochen</ul>
                                            <ul class="dropdown-item" v-else @click="() => { filteredStatus = arrayRemove(filteredStatus,{col: col, status: 'warning'}); tick++;}"><i class="fas fa-circle text-secondary" :alt="'ungültig in '+weeks+' Wochen'"></i>ungültig in {{weeks}} Wochen</ul>

                                            <ul class="dropdown-item" v-if="!filteredStatus.some(obj =>  obj.col === col && obj.status === 'danger' )" @click="() => { filteredStatus.push({col: col, status: 'danger'}); tick++;}"><i class="fas fa-circle text-danger" alt="abgelaufen"></i>abgelaufen</ul>
                                            <ul class="dropdown-item" v-else @click="() => { filteredStatus = arrayRemove(filteredStatus,{col: col, status: 'danger'}); tick++;}"><i class="fas fa-circle text-secondary" alt="abgelaufen"></i>abgelaufen</ul>

                                            <ul class="dropdown-item" v-if="!filteredStatus.some(obj =>  obj.col === col && obj.status === 'primary' )" @click="() => { filteredStatus.push({col: col, status: 'primary'}); tick++;}"><i class="fas fa-circle text-primary" alt="/nicht vorhanden"></i>nicht vorhanden</ul>
                                            <ul class="dropdown-item" v-else @click="() => { filteredStatus = arrayRemove(filteredStatus,{col: col, status: 'primary'}); tick++;}"><i class="fas fa-circle text-secondary" alt="nicht vorhanden"></i>nicht vorhanden</ul>

                                        </template>
                                    </base-dropdown>
                                </div>
                            </div>
                        </th>
                    </template>
                    <template slot-scope="{row}">
                        <td style="width: 80px; white-space: normal !important;"><div v-if="isLoading" class="loading"> </div><div v-else>{{row.name}}</div></td>
                      <!---<td v-if="isAdmin" style="width: 80px; white-space: normal !important;"><div v-if="isLoading" class="loading"> </div><div v-else>{{row.user.customer.name}}</div></td>--->
                      <!---<td style="width: 80px; white-space: normal !important;"><div v-if="isLoading" class="loading"> </div><div v-else>{{(typeof row.user.location !== 'undefined') ? row.user.location : '-'}}</div></td>---->
                      <td v-for="(col,i) in cols" :key="i" class="text-center">
                          <div v-if="isLoading" class="loading"> </div><div v-else>
                          <i class="fas fa-circle" :alt="getStatus(row.profileDocuments,col)" :class="'text-'+getStatus(row.profileDocuments,col)"></i>
                          <base-dropdown class="dropdown"
                                         position="right">
                              <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  <i class="fas fa-ellipsis-v"></i>
                              </a>
                              <template>
                                  <ul class="dropdown-item" v-if="row.profileDocuments.length > 0 && typeof getProfileDoc(row.profileDocuments,col) !== 'undefined'" :class="'text-'+getStatus(row.profileDocuments,col)"><i class="fas fa-calendar-day" :alt="getStatus(row.profileDocuments,col)" :class="'text-'+getStatus(row.profileDocuments,col)"></i><strong>{{(typeof getProfileDoc(row.profileDocuments,col).invalidAt !== "undefined") ? 'ungültig am '+$options.filters.formatDateToDay(getProfileDoc(row.profileDocuments,col).invalidAt) : "unbefristet"}}</strong></ul>
                                  <ul class="dropdown-item text-center" v-if="row.profileDocuments.length > 0 && typeof getProfileDoc(row.profileDocuments,col) !== 'undefined'"><em>{{$options.filters.formatDateFromNow(getProfileDoc(row.profileDocuments,col).invalidAt)}}</em></ul>
                                  <div class="dropdown-divider" v-if="row.profileDocuments.length > 0 && typeof getProfileDoc(row.profileDocuments,col) !== 'undefined'"></div>

                                  <ul class="dropdown-item" v-if="row.profileDocuments.length > 0 && typeof getProfileDoc(row.profileDocuments,col) !== 'undefined'" @click.prevent="downloadFileAndShowDocumentViewer(getProfileDoc(row.profileDocuments,col).document['@id'].replace( /^\D+/g, ''))"><i class="fas fa-eye"></i>Gültige {{col}} ansehen</ul>

                                  <router-link v-if="row.profileDocuments.length > 0 && typeof getProfileDoc(row.profileDocuments,col) !== 'undefined'" class="dropdown-item" :to="'/users/profiles_document_edit/'+ getProfileDoc(row.profileDocuments,col).id"><i class="fas fa-pencil-alt"></i>Gültige {{col}} bearbeiten</router-link>
                                  <router-link v-if="row.profileDocuments.length > 0" class="dropdown-item" :to="'/users/profiles_edit/'+ row.id"><i class="fas fa-certificate"></i>Alle Nachweise des Mitarbeiters</router-link>
                                  <router-link  class="dropdown-item" :to="'/users/profiles_document_create/'+row.id+'/'+col"><i class="ni ni-fat-add"></i>Hinzufügen</router-link>
                              </template>
                          </base-dropdown>
                      </div>
                      </td>
                  </template>
              </base-table>

      </fade-transition>
      </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { BFormInput } from 'bootstrap-vue'
  import FadeTransition from "vue2-transitions/src/Fade/FadeTransition";

  export default {
      name:"matrix",
      components:{FadeTransition, BFormInput},
      data() {
          return {
              profileDocuments: [{
                  id: 0,
                  profile: null,
                  document: null,
                  customer: null,
                  user: null,
                  type: '',
                  name: '',
                  description: '',
                  invalidAt: '',
                  issuedAt: '',
                  createdAt: '',
              }],
              cols: [],
              disabledCols: [],
              isLoading: false,
              orderby: 'invalidAt',
              orderdir: 'asc',
              weeks: 8,
              search: '',
              tick: 1,
              showColumnOptions: [],
              filteredStatus: [] //[[col,status]]
          }
      },
      created() {
          this.init();

      },
      computed: {
          /* profiles() {
              return (!this.$store.getters['profiles/isLoading']) ? Array.from(this.$store.getters['profiles/showProfiles'])
                  .filter(item =>
                  { return item.isActive && !this.isFiltered(this.filteredStatus,item.profileDocuments) &&
                      (item.name.toLowerCase().includes(this.search.toLowerCase()) || (typeof item.user.location !== 'undefined' &&
                          (item.user.location.name.toLowerCase().includes(this.search.toLowerCase()) || item.user.location.externalName.toLowerCase().includes(this.search.toLowerCase())))  || item.user.customer.name.toLowerCase().includes(this.search.toLowerCase()))})
                  : [{name: 'Keine Daten', user: { customer: {name: ''}}, location: {name:''}}];
          }, */
        profiles() {
          return (!this.$store.getters['profiles/isLoading']) ? Array.from(this.$store.getters['profiles/showProfiles'])
                  .filter(item =>
                  { return item.isActive && !this.isFiltered(this.filteredStatus,item.profileDocuments) &&
                      (item.name.toLowerCase().includes(this.search.toLowerCase())) })
              : [{name: 'Keine Daten', user: { customer: {name: ''}}, location: {name:''}}];
        },
          isAdmin() {
              return this.$store.getters['authentication/isAdmin'];
          },
          isService() {
              return this.$store.getters['authentication/isService'];
          },
          expiryDate() {
              return moment().add(this.weeks,'weeks');
          }
      },
      methods: {
          init() {
              this.isLoading = true;
              this.getTableData(this.getUrl()).then(response => {
                  this.profileDocuments = response.member;
                  this.cols = this.getColumns(response.member);
                  this.isLoading = false;
              }, error => {
                  this.isLoading = false;
                  this.$store.dispatch('alert/error',error);
              })

            if (!this.$store.getters['profiles/isLoading'] && !this.$store.getters['profiles/isReady']) this.$store.dispatch('profiles/getProfiles').then();
          },
          getStatus(docs,col) {
              let status = 'primary';
              if (docs.some(element => element.name === col && this.isExpiredInWeeks(element.invalidAt, this.weeks) && typeof element.invalidAt !== "undefined" && element.invalidAt !== null)){
                  status = 'warning';
              } else if (docs.some(element => (element.name === col && (!this.isExpiredInWeeks2(element.invalidAt, this.weeks) || element.invalidAt === null || typeof element.invalidAt === "undefined")))) {
                  status = 'success' }
              else if (docs.some(element => element.name === col && this.isExpired(element.invalidAt))) {
                  status = 'danger'
              }

             return status;
          },
          getProfileDoc(docs,col){
              if (docs.length > 0) {
                  return docs.find(element => element.name === col);

              } else {
                  return {invalidAt: null};
              }
          },
          getColumns(docs) {
              let cols = [];
              docs.forEach(doc => {
                  if (!cols.includes(doc.name)) cols.push(doc.name);
              });
              return cols;
          },
          isExpired(expiry) {
              return moment(expiry).diff(moment()) < 0
          },
          isExpiredInWeeks(expiry, weeks) {
              return !this.isExpired(expiry) && this.expiresInWeeks(expiry) < weeks
          },
          isExpiredInWeeks2(expiry, weeks) {
              return this.expiresInWeeks(expiry) < weeks
          },
          expiresInWeeks(expiry) {
              return moment(expiry).diff(moment(),'weeks');
          },
          getUrl() {
              let pagination = '&pagination=false';
              let url = process.env.VUE_APP_API_SERVER + '/api/profile_documents?order['+this.orderby+']='+this.orderdir + pagination;
              return url;
          },
          order(orderby,orderdir) {
              this.isLoading = true;
              this.orderby = orderby;
              this.orderdir = orderdir;
              this.getTableData(this.getUrl()).then(response => {
                      this.profileDocuments = response.member;
                      this.isLoading = false;
                  }
              );
          },
          getTableData(url) {
              return new Promise((resolve, reject) => {

                  const header = this.authHeader();
                  header['Content-Type'] = 'application/json';
                  const requestOptions = {
                      method:'GET',
                      headers:header
                  };

                  fetch(url, requestOptions)
                      .then(this.handleResponse)
                      .then(response => {
                          resolve({
                              totalItems:response['hydra:totalItems'],
                              member:response['hydra:member']
                          });
                      }, error => {
                          reject(error);
                      });
              });
          },
          arrayRemove(arr, value) {
              return arr.filter(function(ele){
                  return !(ele.col === value.col && ele.status === value.status);
              });
          },
          isFiltered(filters,docs) {
              let result = false;
              docs.forEach(item => {
                  if ( filters.some(status => ( item.name === status.col && this.getStatus([item],status.col) === status.status))) {
                      result = true;
                  }
              });
              if (filters.some(filter => filter.status === 'primary' && !docs.some( doc => doc.name === filter.col)))  result = true;
              return result;
          }

      }
  }
</script>

<style scoped>

</style>